module.exports = __webpack_public_path__ + "img/logo-groupe-esiea.d4509030.svg";